<template>
  <AtomsCalculatorFrame
    iframe-class="!mx-auto"
    :type="type"
    :src="src"
  />
</template>

<script>
export default {
  name: 'MoleculesCalculatorSellingCosts',

  data: () => ({
    type: 'Property_Selling_Cost_Calculator',
    src: '//www.visionabacus.net/Tools/B3/SuiteA/A400/Property_Selling_Cost_Calculator/CompareClub'
  })
}
</script>
